module.exports = __webpack_public_path__ + "static/media/stijn-bessem-case-vodafonerebranding-01@2x.7d7f6abb.jpg";